import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconosGenerales from "../iconos/IconosGenerales";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { visuallyHidden } from '@mui/utils';
import { styled } from '@mui/material/styles';
import PaginacionTabla from '../eventos/filtros/SelectPaginaTabla';
import SelectDinamicoLista from '../eventos/filtros/SelectDinamicoLista';
import SelectNumeroPublicaciones from '../eventos/filtros/SelectNumeroElementos';
import BuscadorCategorias from '../eventos/filtros/BuscadorDinamico';
import funcionOrdenarColumnas from '../eventos/filtros/OrdenarColumnas';
import { useNavigate } from 'react-router-dom';
import CustomTooltip from '../eventos/avisos/Tooltip';
import { CircularProgress } from "@mui/material";
import CalendarioFiltro from './CalendarioFiltro';
import BotonesAccion from "../eventos/navegacion_y_accion/BotonesAccion";
import Alert from '@mui/material/Alert';
import { fetchObtenerWebsDestino } from "../../../peticiones_API/PeticionesWebsDestino";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    textAlign: 'center  !important',
    maxWidth:'50px',
    overflow:'hidden',
    textOverflow: 'ellipsis',
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: 'rgba(0, 60, 102, 0.8)',
        color: theme.palette.common.white,
        padding: '0px',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: '14px ',
        padding: '0px',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    textAlign: 'center  !important',
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const WhiteTableSortLabel = styled(TableSortLabel)(({ theme }) => ({
    textAlign: 'center  !important',
    color: `${theme.palette.common.white} !important`,
    '&.Mui-active .MuiTableSortLabel-icon': {
        color: `${theme.palette.common.white} !important`,
    },
}));


function stableSort(array, comparator) {
    const arrayCopy = [...array];
    arrayCopy.sort(comparator);
    return arrayCopy;
}


function EnhancedTableHead(props) {

    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <StyledTableRow>
                <StyledTableCell padding="checkbox">
                    <Checkbox
                        style={{ color: 'white' }}
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all desserts',
                        }}
                    />
                </StyledTableCell>
                {props.header.map((headCell) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <WhiteTableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </WhiteTableSortLabel>
                    </StyledTableCell>
                ))}
            </StyledTableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

function EnhancedTableToolbar(props) { 
    const { numSelected, personas, setEliminarTodoCategorias, setEliminarCatSelect } = props;
    console.log("personas ", personas);
    const [estadoBusqueda, setEstadoBusqueda] = useState(false);
    const [escribiendo, setEscribiendo] = useState(false);


    const toggleFiltroTodos = (valor, atributo) => {
        console.log("Activar todos");
        console.log("atributo ", atributo);

        if (atributo == "ocultar") {

            setEliminarTodoCategorias((prevState) => ({
                ...prevState,
                valor,
            }));
        }

    };

    const toggleSeleccion = (valor, atributo) => {
        // console.log("Activar select");
        // console.log("atributo ", atributo);

        if (atributo == "ocultar") {

            setEliminarCatSelect((prevState) => ({
                ...prevState,
                valor,
            }));

        }

    };

    return (
        <>
            <Toolbar
                sx={{
                    pl: { sm: 2 },
                    pr: { xs: 1, sm: 1 },
                    ...(numSelected > 0 && {
                        bgcolor: (theme) =>
                            alpha(theme.palette.common.white, theme.palette.action.activatedOpacity),
                    }),
                }}
            >
                {numSelected > 0 ? (
                    <Typography
                        sx={{ flex: '1 1 100%' }}
                        color="inherit"
                        variant="subtitle1"
                        component="div"
                    >
                        {numSelected} selecionado(s)
                    </Typography>
                ) : (
                    <Typography
                        sx={{ flex: '1 1 40%' }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        <BotonesAccion
                            texto="Crear publicación"
                            to="/comunicacion/blogs/crearPublicacion"
                        />
                    </Typography>
                )}


                {numSelected > 0 ? (
                    <>
                        {[
                            { mensaje: "Eliminar página actual", id: "eliminarTodo", handler: () => toggleFiltroTodos(false, "ocultar") },
                            { mensaje: "Eliminar select", id: "eliminarSelect", handler: () => toggleSeleccion(false, "ocultar") },
                        ].map(({ mensaje, id, handler }) => (
                            <CustomTooltip key={id} mensaje={mensaje}>
                                <div>
                                    <IconosGenerales papeleraT="true" id={id} onClick={handler} />
                                </div>
                            </CustomTooltip>
                        ))}
                    </>

                ) : (
                    <>
                        <SelectDinamicoLista opciones={personas} parametroURL="creador" etiqueta="Creador" />
                        <SelectDinamicoLista opciones={personas} parametroURL="editor" etiqueta="Editor" />
                        <CalendarioFiltro
                            parametroURL="fechaInicio"
                            etiqueta="Fecha Inicio"
                        />
                        <CalendarioFiltro
                            parametroURL="fechaFin"
                            etiqueta="Fecha Fin"
                        />
                        <BuscadorCategorias
                            placeholder="Buscar titulo"
                            tooltip="Ej: Titulo"
                            palabra=""
                            estadoBusqueda={estadoBusqueda}
                            setEstadoBusqueda={setEstadoBusqueda}
                            escribiendo={escribiendo}
                            setEscribiendo={setEscribiendo}
                        />

                    </>


                )}
            </Toolbar >
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


function EnhancedTable(props) {
    const navigate = useNavigate();
    const {
        data,
        header,
        meta,
        personas,
        selected,
        setSelected,
        setEliminarTodoCategorias,
        setEliminarCatSelect,
        isLoading,
        fechaIncorrecta
    } = props;

    console.log("meta ", meta);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('categoria');


    // const handleRequestSort = funcionOrdenarColumnas(orderBy, order, setOrderBy, setOrder);

    const handleRequestSort = (event, property) => {
        const nuevaURL = funcionOrdenarColumnas(orderBy, order, setOrderBy, setOrder)(event, property);
        console.log("nuevaURL", nuevaURL);
        navigate(nuevaURL);
    };


    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = data.map((n) => n.id);
            setSelected(newSelected);

            return;
        }
        setSelected([]);
        console.log("seleción", selected);
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }
        setSelected(newSelected);
    };


    const isSelected = (id) => selected.indexOf(id) !== -1;

    const sortedData = stableSort(data);

    // Estado para almacenar las webs destino
    const [WebsDestino, setWebsDestino] = useState([]);

    useEffect(() => {
        const fetchWebsDestino = async () => {
            try {
                const webs = await fetchObtenerWebsDestino();
                setWebsDestino(webs);
            } catch (error) {
                console.error("Error fetching webs destino:", error);
            }
        };

        fetchWebsDestino();
    }, []);
    
    //Establecer un diccionario para mapear los IDs de las webs destino a sus nombres
    const obtenerNombreWebDestino = (ids) => {
        if (ids === null || ids === "-" ) return "-"; // Manejar el caso de IDs vacíos o nulos

        const websIdArray = ids.split(',').map(id => parseInt(id.trim())); // Convertir la cadena de IDs en un array de números
        const nombresWebs = websIdArray.map(id => {
            const web = WebsDestino.find((web) => web.Id === id); // Buscar el nombre de la web destino correspondiente al ID
            return web?.destino ? web?.destino : `ID ${id} no encontrado`; // Devolver el nombre o un mensaje si no se encuentra el ID
        });
        return nombresWebs.join(', '); // Unir los nombres de las webs destino en una sola cadena separada por comas
    }; 

    return (
        <Box sx={{ width: '100%' }}>
            <div>
                <Paper sx={{ width: '98%', mb: 2 }}>

                    <EnhancedTableToolbar
                        numSelected={selected.length}
                        personas={personas}
                        setEliminarTodoCategorias={setEliminarTodoCategorias}
                        setEliminarCatSelect={setEliminarCatSelect}
                    />

                    <Box
                        sx={{
                            position: 'absolute',
                            top: '26%',
                            right: '24.4%',
                            zIndex: 10,
                            width: '260px',
                        }}
                    >
                        {fechaIncorrecta && (
                            <Alert severity="error" variant="filled">
                                Intervalo de fechas incorrecto
                            </Alert>
                        )}
                    </Box>

                    <TableContainer  >
                        <Table sx={{ maxWidth: 2000, minWidth: 1300, }} aria-labelledby="tableTitle">
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={data.length}
                                header={header}
                            />


                            <TableBody>
                                {isLoading ? (
                                    <TableRow hover sx={{ cursor: "default" }}>
                                        <TableCell colSpan={13} style={{ textAlign: "center" }}>
                                            <CircularProgress style={{ color: "rgba(0, 60, 102, 0.8)" }} />
                                        </TableCell>
                                    </TableRow>
                                ) : (

                                    sortedData.map((row, index) => {
                                        const isItemSelected = isSelected(row.id);
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (
                                            <StyledTableRow
                                                hover
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.id}
                                                selected={isItemSelected}
                                            >
                                                <StyledTableCell padding="checkbox">
                                                    <Checkbox
                                                        color="default"
                                                        onClick={(event) => handleClick(event, row.id)}
                                                        checked={isItemSelected}
                                                        inputProps={{ 'aria-labelledby': labelId }}
                                                    />
                                                </StyledTableCell>

                                                <StyledTableCell
                                                    component="th"
                                                    id={labelId}
                                                    scope="row"
                                                    padding="none"
                                                >
                                                    {row.titulo}
                                                </StyledTableCell>
                                                
                                                <StyledTableCell align="left">{row.fechaPublicacion}</StyledTableCell>
                                                
                                                <StyledTableCell align="right">{row.creador}</StyledTableCell>
                                                <StyledTableCell align="right">{row.editor}</StyledTableCell>
                                                <StyledTableCell align="right">{row.categoria}</StyledTableCell>
                                                <StyledTableCell align="right">{obtenerNombreWebDestino(row.webDestino)}</StyledTableCell>
                                                
                                               <StyledTableCell align="right">
                                                    <IconosGenerales
                                                        tabla="true"
                                                        id="edit"
                                                        to={`/comunicacion/blogs/editarPublicacion/${row.url}`}
                                                    />
                                                </StyledTableCell>
                                            </StyledTableRow>
                                        );
                                    })
                                )}

                            </TableBody>
                        </Table>
                    </TableContainer>

                </Paper>
            </div>

            {!isLoading && (
                <>
                    <PaginacionTabla
                        totalPages={meta.totalPages}

                    />
                    <SelectNumeroPublicaciones
                        perPage={meta.per_page}
                    />
                </>
            )}

            <Typography
                variant="body2"
                sx={{
                    mr: '2%',
                    textAlign: 'right',
                    fontWeight: 'bold',
                    fontSize: '16px',
                    gap: "8px", marginTop: "-30px",
                    color: 'rgba(0, 60, 102, 0.8)',
                }}
            >
                Total registros: {meta.total || 0}
            </Typography>
        </Box>
    );
}

EnhancedTable.propTypes = {
    data: PropTypes.array.isRequired,
    header: PropTypes.array.isRequired,
    meta: PropTypes.object.isRequired,
};

export default EnhancedTable;